export default function filledY(datum, options) {
  const { y } = datum
  if (y) return y
  const { fill: fillOption = null, x } = options
  if (fillOption === 'x') return x
  if (fillOption === 0) return 0
  if (fillOption) return fillOption
  return null
}
